module.exports = __webpack_public_path__ + "e90b9be1b8b3d69b4675b095f4df1fec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/low_12.jpg
// module id = 1729
// module chunks = 5